<template>
  <div>
    <notifications group="appNotification" />
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import axios from "axios";
import store from "./store";
export default {
  name: "App",
  data() {
    return {
      oldOrders: [],
    };
  },
  beforeMount() {
    // this.getProducts();
  },
  mounted() {
    // this.$nextTick(function () {
    //   window.setInterval(() => {
    //     this.getProducts();
    //   }, 10000);
    // });
  },
  methods: {
    // getProducts() {
    //   axios({
    //     url: "/order/all",
    //     method: "GET",
    //     headers: {
    //       Authorization: "Bearer " + localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.data) {
    //         if (this.oldOrder != response.data.data) {
    //           this.oldOrder = response.data.data;
    //           console.log("hi");
    //         } else {
    //           return;
    //         }
    //       }
    //     })
    //     .catch((e) => {
    //       this.ServerError = true;
    //     });
    // },
    tokenParse(item) {
      var base64Url = item.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      store.commit("loginUser", JSON.parse(jsonPayload));
      return JSON.parse(jsonPayload);
    },
  },
};
</script>
<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
//View Data Style
</style>
<style >
a:hover {
  text-decoration: none !important;
}
.item_heading {
  font-size: 18px;
  font-weight: 500;
  color: #a2a2a2;
}
.item_title {
  font-size: 14px;
  font-weight: 500;
}
.item_value {
  font-size: 14px;
  font-weight: 400;
  color: #a9a9a9;
}
/* Fix for Account menu width issue */
.app-header .dropdown-item {
  min-width: 0px !important;
}
</style>